var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConstruction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.24,124h-7.94c-1.66,0-3-1.34-3-3V77.27h13.94V121C27.24,122.66,25.89,124,24.24,124z",
    style: {
      fill: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.51,124h-7.94c-1.66,0-3-1.34-3-3V77.27h13.94V121C115.51,122.66,114.17,124,112.51,124z",
    style: {
      fill: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.24,79.27V121c0,0.55-0.45,1-1,1h-7.94c-0.55,0-1-0.45-1-1V79.27H25.24 M27.24,77.27H13.29V121 c0,1.66,1.34,3,3,3h7.94c1.66,0,3-1.34,3-3V77.27L27.24,77.27z",
    style: {
      fill: "#424242"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.51,79.27V121c0,0.55-0.45,1-1,1h-7.94c-0.55,0-1-0.45-1-1V79.27H113.51 M115.51,77.27h-13.94 V121c0,1.66,1.34,3,3,3h7.94c1.66,0,3-1.34,3-3V77.27L115.51,77.27z",
    style: {
      fill: "#424242"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 64,
    x2: 64,
    y1: 39.1923,
    y2: 81.0202
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0256,
    style: {
      stopColor: "#FFEE58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4867,
    style: {
      stopColor: "#FDD642"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBC02D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M120,82.17H8c-2.21,0-4-1.79-4-4V44.63c0-2.21,1.79-4,4-4h112c2.21,0,4,1.79,4,4v33.54 C124,80.38,122.21,82.17,120,82.17z",
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.35,
    cy: 31.4,
    r: 9.04,
    style: {
      fill: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.35,
    cy: 31.4,
    r: 6.73,
    style: {
      fill: "#F44336"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.54,
    cy: 31.4,
    r: 9.04,
    style: {
      fill: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.54,
    cy: 31.4,
    r: 6.73,
    style: {
      fill: "#F44336"
    }
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_2_",
    d: "M120,82.17H8c-2.21,0-4-1.79-4-4V44.63c0-2.21,1.79-4,4-4h112c2.21,0,4,1.79,4,4v33.54 C124,80.38,122.21,82.17,120,82.17z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_2_"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_3_)"
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "-15.62,88.64 -33.58,88.64 -2.13,34.16 15.84,34.16 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "20.82,88.64 2.85,88.64 34.31,34.16 52.27,34.16 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "57.26,88.64 39.29,88.64 70.74,34.16 88.71,34.16 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "93.69,88.64 75.73,88.64 107.18,34.16 125.15,34.16 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "130.13,88.64 112.16,88.64 143.62,34.16 161.58,34.16 "
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120,43.63c0.55,0,1,0.45,1,1v33.54c0,0.55-0.45,1-1,1H8c-0.55,0-1-0.45-1-1V44.63 c0-0.55,0.45-1,1-1H120 M120,40.63H8c-2.21,0-4,1.79-4,4v33.54c0,2.21,1.79,4,4,4h112c2.21,0,4-1.79,4-4V44.63 C124,42.43,122.21,40.63,120,40.63L120,40.63z",
    style: {
      fill: "#424242"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/construction.3923fb48647327ca6f47f5e6a318fa3c.svg";
export { ForwardRef as ReactComponent };